module.exports = __webpack_public_path__ + "static/media/david-troeger-9-xzy-ez-pahmi-unsplash-copy-3.965649d0.jpg";